/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultReviewCard from "examples/Cards/ReviewCards/DefaultReviewCard";

function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2">Más de 78.000</MKTypography>
          <MKTypography variant="h2" color="info" textGradient mb={2}>
            Pasaron por nuestro sindicato desde nuestra creación, no esperes más.
          </MKTypography>
          <MKTypography variant="body1" color="text" mb={2}>
            Llevamos mas de 100 años ofreciendo mejores condiciones para nuestros compañeros, no
            esperes mas y unite a nuestra lucha.
          </MKTypography>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 8 }}>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Maria Isabel Escobar"
              date="hace 1 dia"
              review="Me uni ayer y me enteré que el sindicato tiene hotel en mar del Plata, ya tengo  nuevo destino para vacaciones."
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Ernesto Morito"
              date="hace 1 semana"
              review="Sufria de maltrato laboral y gracias a la Dra. Plazibat pude mejorar mi situación, tambien doy gracias al secretario General Jorge Bustos"
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Samuel Gonzalez"
              date="hace 3 semanas"
              review="Hace mas de un mes que voy al gimnasio y pago solo el 70% de lo que vale,  esta buenisimo."
              rating={5}
            />
          </Grid>
        </Grid>
        <Divider sx={{ my: 6 }} />
      </Container>
    </MKBox>
  );
}

export default Information;
